export default function NotFound(){
    return(
        <iframe className="not-found" title="404" src="https://web.axc.ae/soon" frameBorder="0"></iframe>
    )
}